import HyperDX from "@hyperdx/browser";

let initialized = false;
export const initBrowserTracing = ({ apiKey, service }: { apiKey?: string; service: string }) => {
  if (initialized || !apiKey) {
    return;
  }
  try {
    HyperDX.init({
      apiKey,
      service,
      tracePropagationTargets: [/.+[.]jurni[.]ai/i],
      instrumentations: {
        interactions: false,
        document: false,
        fetch: {
          ignoreUrls: [/^(?!.*\.getjurni\.ai).*$/i],
        },
        xhr: {
          ignoreUrls: [/^(?!.*\.getjurni\.ai).*$/i],
        },
        websocket: false,
        longtask: false,
        postload: false,
        socketio: false,
        webvitals: false,
      },
      consoleCapture: true,
      advancedNetworkCapture: true,
      disableReplay: true,
      disableIntercom: true,
    });
    initialized = true;
  } catch (error) {
    console.error("Error initializing HyperDX browser tracing", error);
  }
};

export const addAction = ({ name, attributes }: { name: string; attributes: Record<string, string> }) => {
  HyperDX.addAction(name, attributes);
};
